import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { editSubscriptionTypeFailed, editSubscriptionTypeSuccessful } from '../actions';
import { OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* editSubscriptionType(action) {
  try {
    const {
      id,
      ...body
    } = action.payload;
    delete body.created_at;
    delete body.updated_at;
    const url = `${BACKEND_URL}/proxy/subscription/v1/presets/${id}`;
    const dataResponse = yield makeRequest(url, body, action, 'PATCH', true);
    if (dataResponse.status === OK) {
      yield put(editSubscriptionTypeSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(editSubscriptionTypeFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(editSubscriptionTypeFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
